import { render, staticRenderFns } from "./AboutDialog.vue?vue&type=template&id=d7eda3c0&scoped=true"
import script from "./AboutDialog.vue?vue&type=script&lang=ts"
export * from "./AboutDialog.vue?vue&type=script&lang=ts"
import style0 from "./AboutDialog.vue?vue&type=style&index=0&id=d7eda3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7eda3c0",
  null
  
)

export default component.exports